var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCloseWhite13X13 = function SvgCloseWhite13X13(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "main-color-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.141,
    height: 12.14
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m7.496 6.069 4.347-4.336A1.016 1.016 0 0 0 10.406.297L6.071 4.644 1.735.297A1.015 1.015 0 0 0 .299 1.733l4.347 4.336-4.347 4.335a1.015 1.015 0 1 0 1.435 1.435L6.07 7.492l4.336 4.349a1.016 1.016 0 1 0 1.437-1.437Z"
  })));
};
export default SvgCloseWhite13X13;